const { haversineDistance } = require("../haversineDistance.js");
const { getCachedDistance } = require("../realRouteDistance.js");

/**
 * Sipariş ve araç arasındaki mesafeyi hesaplar.
 * @param {Object} order - Sipariş detayları.
 * @param {Object} vehicle - Araç detayları.
 * @param {Object} cachedDistances - Önceden hesaplanmış mesafeler (opsiyonel)
 * @returns {number} Sipariş ve araç arasındaki mesafe (km cinsinden).
 */
function calculateDistancePriority(order, vehicle, cachedDistances = null) {
  // Null safety: vehicle.planning null olabilir - kritik bug fix
  const fromLocation =
    vehicle?.orderNos?.length && !vehicle.orderNos.includes(order.orderNo) && vehicle?.planning
      ? {
          lat: parseFloat(vehicle.planning.targetPointLat || vehicle.latitude || 0),
          lng: parseFloat(vehicle.planning.targetPointLng || vehicle.longitude || 0),
        }
      : {
          lat: parseFloat(vehicle?.latitude || 0),
          lng: parseFloat(vehicle?.longitude || 0),
        };

  const orderLocation = {
    lat: parseFloat(
      order?.startLat
        ? order?.startLat
        : order?.outpointLat
        ? order?.outpointLat
        : order?.fillingLatitude || 0
    ),
    lng: parseFloat(
      order?.startLng
        ? order?.startLng
        : order?.outpointLng
        ? order?.outpointLng
        : order?.fillingLongitude || 0
    ),
  };

  // 1. Eğer cachedDistances parametresi verilmişse ordan al
  if (cachedDistances && vehicle.id) {
    const cachedDistance = cachedDistances[vehicle.id];
    if (cachedDistance !== undefined) {
      return cachedDistance;
    }
  }

  // 2. Koordinat validation
  if (!orderLocation.lat || !orderLocation.lng || !fromLocation.lat || !fromLocation.lng) {
    return Infinity;
  }

  // 3. Sıfır koordinat kontrolü (GPS verisi yok)
  if ((orderLocation.lat === 0 && orderLocation.lng === 0) ||
      (fromLocation.lat === 0 && fromLocation.lng === 0)) {
    return Infinity;
  }

  // 4. OSRM cache'inden bak (daha önce hesaplanmış gerçek yol mesafesi varsa)
  const cachedOsrmDistance = getCachedDistance(fromLocation, orderLocation);
  if (cachedOsrmDistance !== null) {
    return cachedOsrmDistance;
  }

  // 5. Haversine ile hesapla (fallback)
  const distance = haversineDistance(orderLocation, fromLocation);

  return distance;
}


module.exports={
    calculateDistancePriority
}